
document.addEventListener('DOMContentLoaded', () => {

  const dataElement = document.getElementById(
    'birthstone-combinations-json'
  );

  if (!dataElement) return;

  const combinations = JSON.parse(
    dataElement.textContent
  );

  initStickyNav();
  initFinder(combinations);
  initFilters(combinations);

});

/* ==========================================================
   STICKY NAV
========================================================== */

function initStickyNav() {

  const links = document.querySelectorAll(
    '.birthstone-anchor-nav a'
  );

  if (!links.length) return;

  links.forEach(link => {

    link.addEventListener('click', e => {

      const href = link.getAttribute('href');

      if (!href.startsWith('#')) return;

      const target = document.querySelector(href);

      if (!target) return;

      e.preventDefault();

      const nav =
        document.querySelector('.birthstone-anchor-nav');

      const offset =
        nav ? nav.offsetHeight + 20 : 100;

      const y =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });

    });

  });

}

/* ==========================================================
   MONTH FINDER
========================================================== */

function initFinder(combinations) {

  const month1 =
    document.getElementById(
      'birthstone-month-1'
    );

  const month2 =
    document.getElementById(
      'birthstone-month-2'
    );

  const button =
    document.getElementById(
      'find-birthstone-combination'
    );

  if (!button) return;

  button.addEventListener('click', () => {

    const m1 = month1.value;
    const m2 = month2.value;

    if (!m1 || !m2) {

      alert(
        'Please select two birth months.'
      );

      return;

    }

    const result = combinations.find(item => {

      const direct =

        item.month1 === m1 &&
        item.month2 === m2;

      const reverse =

        item.month1 === m2 &&
        item.month2 === m1;

      return direct || reverse;

    });

    renderFinderResult(result);

  });

}

/* ==========================================================
   FINDER RESULT
========================================================== */

function renderFinderResult(result) {

  const container =
    document.getElementById(
      'birthstone-finder-result'
    );

  if (!container) return;

  if (!result) {

    container.style.display = 'block';

    container.innerHTML = `
      <div class="finder-no-result">
        No matching birthstone combination found.
      </div>
    `;

    return;

  }

  const image =
    document.getElementById(
      'finder-image'
    );

  const title =
    document.getElementById(
      'finder-title'
    );

  const meaning =
    document.getElementById(
      'finder-meaning'
    );

  const description =
    document.getElementById(
      'finder-description'
    );

  const bestFor =
    document.getElementById(
      'finder-best-for'
    );

  const products =
    document.getElementById(
      'finder-products'
    );

  container.style.display = 'block';

  image.innerHTML = result.image
    ? `<img src="${result.image}" alt="${result.title}">`
    : '';

  title.textContent = result.title || '';

  meaning.textContent =
    result.meaning || '';

  description.innerHTML =
    result.description || '';

  bestFor.textContent =
    Array.isArray(result.best_for)
      ? result.best_for.join(' • ')
      : '';

  let productsHtml = '';

  if (
    result.products &&
    result.products.length
  ) {

    result.products.forEach(product => {

      productsHtml += `
        <a
          href="${product.url}"
          class="finder-product">

          ${
            product.image
              ? `<img src="${product.image}" alt="${product.title}">`
              : ''
          }

          <span>
            ${product.title}
          </span>

        </a>
      `;

    });

  }

  products.innerHTML = productsHtml;

  const offset = 120;

  const y =
    container.getBoundingClientRect().top +
    window.pageYOffset -
    offset;

  window.scrollTo({
    top: y,
    behavior: 'smooth'
  });

}

/* ==========================================================
   SEARCH + FILTERS
========================================================== */

function initFilters(combinations) {

  populateFilterOptions(combinations);

  const search =
    document.getElementById(
      'birthstone-search'
    );

  const gemstone1 =
    document.getElementById(
      'filter-gemstone-1'
    );

  const gemstone2 =
    document.getElementById(
      'filter-gemstone-2'
    );

  const meaning =
    document.getElementById(
      'filter-meaning'
    );

  const bestFor =
    document.getElementById(
      'filter-best-for'
    );

  [
    search,
    gemstone1,
    gemstone2,
    meaning,
    bestFor

  ].forEach(el => {

    if (!el) return;

    el.addEventListener(
      'input',
      filterCards
    );

    el.addEventListener(
      'change',
      filterCards
    );

  });

}

/* ==========================================================
   POPULATE FILTERS
========================================================== */

function populateFilterOptions(
  combinations
) {

  buildUniqueOptions(
    combinations.map(
      c => c.gemstone1
    ),
    'filter-gemstone-1'
  );

  buildUniqueOptions(
    combinations.map(
      c => c.gemstone2
    ),
    'filter-gemstone-2'
  );

  const meaningValues = [];

combinations.forEach(item => {

  if (!item.meaning) return;

  item.meaning
    .split(',')

    .forEach(word => {

      const cleaned = word.trim();

      if (cleaned) {
        meaningValues.push(cleaned);
      }

    });

});

buildUniqueOptions(
  meaningValues,
  'filter-meaning'
);

  const bestForValues = [];

  combinations.forEach(item => {

    if (
      Array.isArray(
        item.best_for
      )
    ) {

      item.best_for.forEach(v => {

        bestForValues.push(v);

      });

    }

  });

  buildUniqueOptions(
    bestForValues,
    'filter-best-for'
  );

}

function buildUniqueOptions(
  values,
  selectId
) {

  const select =
    document.getElementById(
      selectId
    );

  if (!select) return;

  const currentFirst =
    select.options[0];

  select.innerHTML = '';

  select.appendChild(
    currentFirst
  );

  [...new Set(values)]
    .filter(Boolean)
    .sort()
    .forEach(value => {

      const option =
        document.createElement(
          'option'
        );

      option.value = value;
      option.textContent = value;

      select.appendChild(option);

    });

}

/* ==========================================================
   FILTER CARDS
========================================================== */

function filterCards() {

  const searchValue =
    document
      .getElementById(
        'birthstone-search'
      )
      .value
      .toLowerCase()
      .trim();

  const gemstone1 =
    document.getElementById(
      'filter-gemstone-1'
    ).value;

  const gemstone2 =
    document.getElementById(
      'filter-gemstone-2'
    ).value;

  const meaning =
    document.getElementById(
      'filter-meaning'
    ).value;

  const bestFor =
    document.getElementById(
      'filter-best-for'
    ).value;

  const cards =
    document.querySelectorAll(
      '.combination-card'
    );

  cards.forEach(card => {

    let visible = true;

    const title =
      (
        card.dataset.title || ''
      ).toLowerCase();

    const month1 =
      (
        card.dataset.month1 || ''
      ).toLowerCase();

    const month2 =
      (
        card.dataset.month2 || ''
      ).toLowerCase();

    const gem1 =
      card.dataset.gemstone1 || '';

    const gem2 =
      card.dataset.gemstone2 || '';

    const cardMeaning =
      card.dataset.meaning || '';

    const cardBestFor =
      card.dataset.bestFor || '';

    if (searchValue) {

      const searchableText = [

        title,

        month1,
        month2,

        gem1,
        gem2,

        cardMeaning,

        cardBestFor

      ]
        .join(' ')
        .toLowerCase();

      const match =
        searchableText.includes(
        searchValue
        );

      if (!match) {
       visible = false;
      }

    }

    if (
      gemstone1 &&
      gem1 !== gemstone1
    ) {
      visible = false;
    }

    if (
      gemstone2 &&
      gem2 !== gemstone2
    ) {
      visible = false;
    }

    if (
  meaning &&
  !cardMeaning
    .toLowerCase()
    .includes(
      meaning.toLowerCase()
    )
    ) {
  visible = false;
    }

    if (
      bestFor &&
      !cardBestFor.includes(
        bestFor
      )
    ) {
      visible = false;
    }

    card.style.display =
      visible ? '' : 'none';

  });

}